import React, { useEffect, useState } from "react";
import "./profile.css";
import { UserStore } from "../store/store";
import { Link } from "react-router-dom";
import {
  clearFavourites,
  clearWatchHistory,
  formatTimeStamp,
} from "../javascript/function";
import Global from "../../global";
import CarouselContentLoader from "../loader/contentLoader";
import NotFound from "../notfound/notfound";
import PhoneModal from "../modals/phoneModal";
import PWDModal from "../modals/pwdModal";
import NameModal from "../modals/nameModal";
import CardModal from "../modals/cardModal";
import { DarkModeStore } from "../store/darkModeStore";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getSetting,
  intializeSetting,
  setSetting,
  isEmpty,
  saveSetting,
} from "../javascript/function";
import InPlayer from "../backend/inplayer";
import { useTranslation } from "react-i18next";

const Profile = (props) => {
  const currentUser = UserStore.useState((s) => s.user);
  const [loading, setLoading] = useState(true);
  const [phoneShow, setPhoneShow] = useState(false);
  const [pwdShow, setPwdShow] = useState(false);
  const [cardShow, setCardShow] = useState(false);
  const [nameShow, setNameShow] = useState(false);
  const theme = DarkModeStore.useState((s) => s.themeMode);
  const [themeType, setTheme] = useState(theme);
  const [subscriptions, setSubscriptions] = useState([]);
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const { t } = useTranslation(["translation"]);

  const onOpenPhoneModal = (event) => {
    event.preventDefault();
    setPhoneShow(true);
  };
  const onClosePhoneModal = () => {
    setPhoneShow(false);
  };
  const onOpenPWDModal = (event) => {
    event.preventDefault();
    setPwdShow(true);
  };
  const onClosePWDModal = () => {
    setPwdShow(false);
  };
  const onOpenNameModal = (event) => {
    event.preventDefault();
    setNameShow(true);
  };
  const onCloseNameModal = () => {
    setNameShow(false);
  };

  const onOpenCardModal = (event) => {
    event.preventDefault();
    setCardShow(true);
  };
  const onCloseCardModal = () => {
    setCardShow(false);
  };

  const changeThemeMode = (event) => {
    event.preventDefault();
    DarkModeStore.update((s) => {
      s.themeMode = !themeType;
    });
    setTheme(!themeType);

    let settings = getSetting();
    if (!isEmpty(settings)) {
      settings.DARK_MODE = !themeType;
      setSetting(settings);
      saveSetting(settings);
    } else {
      settings = intializeSetting();
      settings.DARK_MODE = !themeType;
      setSetting(settings);
      saveSetting(settings);
    }
  };

  const cancelSubscription = async (token_url) => {
    setLoading(true);
    InPlayer.Subscription.cancelSubscription(token_url)
      .then((data) => {
        setLoading(false);
        toastr.success("Sucessfully Cancelled Subscription", "Success");
      })
      .catch((error) => {
        setLoading(false);
        toastr.error("Error in Cancelling Subscription", "Error");
      });
  };

  useEffect(() => {
    async function fetchSubscriptions() {
      await InPlayer.Subscription.getSubscriptions(0, 15, "recurrent")
        .then((data) => {
          setSubscriptions(data.data.collection);
        })
        .catch((error) => {});
    }

    async function fetchPurchaseHistory() {
      InPlayer.Payment.getPurchaseHistory("active", 0, 5)
        .then((data) => {
          setPurchaseHistory(data.data.collection);
        })
        .catch((error) => {});
    }
    setLoading(true);
    if (currentUser.NAME && currentUser.EMAIL) {
      fetchSubscriptions();
      fetchPurchaseHistory();
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [currentUser.NAME, currentUser.EMAIL]);

  if (!loading && currentUser.NAME && currentUser.EMAIL) {
    return (
      <div className="profile" id="profile" style={{ paddingTop: "80px" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="sign-user_card">
                <h5 className="mb-3 pb-3 a-border">
                  {t("label_Account_Details")}
                </h5>
                <div className="row align-items-center justify-content-between mb-3">
                  <div className="col-md-8">
                    <span className="text_main bold">{currentUser.EMAIL}</span>
                  </div>
                  <div className="col-md-4 text-md-right text-left"></div>
                </div>
                <div className="row align-items-center justify-content-between mb-3">
                  <div className="col-md-8">
                    <span className="text_second">{currentUser.NAME}</span>
                  </div>
                  <div className="col-md-4 text-md-right text-left">
                    <Link
                      to="#!"
                      className="text-primary"
                      onClick={onOpenNameModal}
                    >
                      {t("btn_Change")}
                    </Link>
                  </div>
                </div>
                <div className="row align-items-center justify-content-between mb-3">
                  <div className="col-md-8">
                    <span className="text_second font-size-13">
                      {t("label_Password")}
                    </span>
                    <p className="mb-0 text_second">**********</p>
                  </div>
                  <div className="col-md-4 text-md-right text-left">
                    <Link
                      to="#!"
                      className="text-primary"
                      onClick={onOpenPWDModal}
                    >
                      {t("btn_Change")}
                    </Link>
                  </div>
                </div>
                <div className="row align-items-center justify-content-between mb-3">
                  <div className="col-md-8">
                    <span className="text_second font-size-13">
                      {t("label_Phone_Number")}
                    </span>
                    <p className="mb-0 text_second">{currentUser.PHONE}</p>
                  </div>
                  <div className="col-md-4 text-md-right text-left">
                    {/*      <Link
                      to="#!"
                      className="text-primary"
                      onClick={onOpenPhoneModal}
                    >
                      Change
                    </Link> */}
                  </div>
                </div>
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-8">
                    <span className="text_second font-size-13">
                      {t("label_Country")}
                    </span>
                    <p className="mb-0 text_second">{currentUser.COUNTRY}</p>
                  </div>
                  <div className="col-md-4 text-md-right text-left"></div>
                </div>
                <h5 className="mb-3 mt-4 pb-3 a-border">
                  {t("label_Active_Subscription")}
                </h5>
                <div className="row justify-content-between mb-3">
                  <div className="col-md-8 r-mb-15">
                    <p className="text_second">
                      {t("label_Active_Subscription_Desc")}
                    </p>
                  </div>
                  <div className="col-md-4 text-md-right text-left">
                    <Link
                      to="#!"
                      className="text-primary"
                      onClick={onOpenCardModal}
                    >
                      {t("btn_Update_Payment_Info")}
                    </Link>
                  </div>
                  <div className="col-md-12">
                    <ul className="subUL">
                      {subscriptions.length > 0 && subscriptions !== null ? (
                        subscriptions.map((elem, index) => (
                          <li key={index}>
                            <a className="plan-block" href="#!">
                              {elem.item_title}
                              <span>
                                {t("label_Next_Billing_Date") +
                                  " : " +
                                  formatTimeStamp(elem.next_rebill_date)}
                              </span>
                              <span>{elem.formatted_amount}</span>
                            </a>

                            {/*        <Link
                              className="text-primary"
                              to="#!"
                              onClick={(event) => {
                                event.preventDefault();
                                changePlan(elem.subscription_id);
                              }}
                            >
                              Change Plan
                            </Link> */}
                            <Link
                              className="text-primary"
                              to="#!"
                              onClick={(event) => {
                                event.preventDefault();
                                cancelSubscription(elem.unsubscribe_url);
                              }}
                            >
                              {t("btn_Cancel_Subscription")}
                            </Link>
                          </li>
                        ))
                      ) : (
                        <li key={"nothing_0"}>
                          <a className="plan-block" href="#!">
                            {t("label_No_Active_Subscription")}
                            <span>{t("btn_Subscribe")}</span>
                          </a>

                          <Link
                            className="text-primary"
                            to={"/" + props.match.params.AppId + "/premium"}
                          >
                            {t("label_Premium")}
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <h5 className="mb-3 mt-4 pb-3 a-border">
                  {t("label_All_Purchase")}
                </h5>
                <div className="row justify-content-between mb-3">
                  <div className="col-md-8">
                    <p>{t("label_All_Purchase_Desc")}</p>
                  </div>

                  <div className="col-md-12">
                    <ul className="subUL">
                      {purchaseHistory.length > 0 &&
                      purchaseHistory !== null ? (
                        purchaseHistory.map((elem, index) => (
                          <li key={index}>
                            <a className="plan-block" href="#!">
                              {elem.item_title}
                              <span>
                                {t("label_Payment_Expiry") +
                                  " : " +
                                  formatTimeStamp(elem.expires_at)}
                              </span>
                              <span>
                                {elem.purchased_amount +
                                  " " +
                                  elem.purchased_currency}
                              </span>
                              <span>
                                {t("label_Payment_Type") +
                                  " : " +
                                  elem.payment_method}
                              </span>
                              <span>
                                {t("label_Purchased_On") +
                                  formatTimeStamp(elem.created_at)}
                              </span>
                            </a>
                          </li>
                        ))
                      ) : (
                        <li key={"nothing_0"}>
                          <a className="plan-block" href="#!">
                            {t("label_No_Active_Purchase")}
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <h5 className="mb-3 pb-3 mt-4 a-border">
                  {t("label_Setting")}
                </h5>

                <div className="row align-items-center justify-content-between mb-3">
                  <div className="col-md-8">
                    <span className="text_main bold">
                      {currentUser.SETTINGS.DARK_MODE || themeType
                        ? Global.DARK_MODE
                          ? "Dark Mode : Enabled"
                          : "Light Mode : Enabled"
                        : Global.DARK_MODE
                        ? "Dark Mode : Disabled"
                        : "Light Mode : Disabled"}
                    </span>
                  </div>
                  <div className="col-md-4 text-md-right text-left">
                    <Link
                      to="#!"
                      className="text-primary"
                      onClick={changeThemeMode}
                    >
                      {t("btn_Change")}
                    </Link>
                  </div>
                </div>
                <div className="row align-items-center justify-content-between mb-3">
                  <div className="col-md-8">
                    <span className="text_main bold">
                      {t("label_Language") + " : " + currentUser.SETTINGS.LAN}
                    </span>
                  </div>
                  <div className="col-md-4 text-md-right text-left"></div>
                </div>

                <h5 className="mb-3 pb-3 mt-4 a-border">{t("label_Others")}</h5>
                <div className="row">
                  <div className="col-12 setting">
                    {/* <a href="#!" className="text-body d-block mb-1">
                      Device Management
                    </a> */}
                    <a href="#!" className="text-body d-block mb-1">
                      {t("btn_Transaction_History")}
                    </a>
                    {/*  <a href="#!" className="text-body d-block mb-1">
                      Activate a Device
                    </a>
                    <a href="#!" className="text-body d-block mb-1">
                      Privacy Management
                    </a> */}
                    {Global.WATCHHISTORY ? (
                      <Link
                        to="#!"
                        className="text-body d-block"
                        onClick={(event) => {
                          clearWatchHistory(currentUser.WATCHHISTORY, event);
                        }}
                      >
                        {t("btn_Clear_Watch_History")}
                      </Link>
                    ) : (
                      ""
                    )}
                    {Global.FAVOURITES ? (
                      <Link
                        to="#!"
                        className="text-body d-block"
                        onClick={(event) => {
                          clearFavourites(currentUser.FAVOURITES, event);
                        }}
                      >
                        {t("btn_Clear_Favourites")}
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <NameModal
          open={nameShow}
          currentName={currentUser.NAME}
          onCloseModal={onCloseNameModal}
          onOpenModal={onOpenNameModal}
          OEM={Global.SRM}
        ></NameModal>
        <PhoneModal
          open={phoneShow}
          onCloseModal={onClosePhoneModal}
          onOpenModal={onOpenPhoneModal}
        ></PhoneModal>
        <PWDModal
          open={pwdShow}
          onCloseModal={onClosePWDModal}
          onOpenModal={onOpenPWDModal}
        ></PWDModal>
        <CardModal
          open={cardShow}
          onCloseModal={onCloseCardModal}
          onOpenModal={onOpenCardModal}
        ></CardModal>
      </div>
    );
  } else if (!loading && !currentUser.NAME && !currentUser.EMAIL) {
    return <NotFound code={""} message={""}></NotFound>;
  } else {
    return <CarouselContentLoader></CarouselContentLoader>;
  }
};

export default Profile;
